import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-profile-image-my-data',
  templateUrl: './profile-image-my-data.component.html',
  styleUrls: ['./profile-image-my-data.component.scss'],
})
export class ProfileImageMyDataComponent implements OnInit {
  @Input('type') type: string = 'person'; //tipos: person, link
  @Input('accept') accept: string = '.jpg, .png';
  @Input('initials') initials: string = 'DD';
  @Input('image') image: string = ''
  @Output('onImageChange') onImageChange: EventEmitter<File>;


  file!: File;
  imageUrl: string = ''; //tipos: person, link

  constructor() {
    this.onImageChange = new EventEmitter();
  }

  ngOnInit(): void {}

  imageChange(event:any){
    console.log('evento ', event)
    this.file = event.target.files[0];
    console.log('FILE ', this.file)
    this.onImageChange.emit(this.file)
  }

}
